import React, { useEffect } from 'react'
import "./UnAuthorizedPage.css";
import { useSelector } from 'react-redux';
import { Spinner } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useGetSingleUserDataQuery } from '../../../redux-toolkit/services/UserAuthApi/UserAuthApi';
const UnAuthorizedPage = () => {
    const navigate = useNavigate();
    const { AuthInfo } = useSelector((state) => state?.auth);
    const { data, isLoading, error } = useGetSingleUserDataQuery(
        AuthInfo?._id,
        { skip: !AuthInfo?._id }
    );
    useEffect(() => {
        if (data?.data?._id) {
            navigate("/");
        }

    }, [data])

    if (isLoading || data?.data?._id) {
        return (<>
            <div style={{
                height: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
            }}>
                <Spinner animation="border" variant="danger" />
            </div>
        </>);
    }


    return (
        <>
            <section className="UnAuthorizedPage">
                <div className="text-wrapper">
                    <div className="title" data-content="404">
                        403 - ACCESS DENIED
                    </div>

                    <div className="subtitle">
                        Oops, You don't have permission to access this page.
                    </div>



                </div>
            </section>

        </>
    )
}

export default UnAuthorizedPage;